import React from "react";
import { Container } from "reactstrap";
import VVSTable from "components/form-control/VVSTable";

export default function Commission() {
  return (
    <div className="page-content">
      <Container fluid>
        <VVSTable name="Commission" title={"Chính sách hoa hồng và thưởng"} />
      </Container>
    </div>
  );
}
